module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-between grow-1 flex-wrap result-border pb-2 pt-2"
  }, [_c('router-link', {
    staticClass: "fs-7 fw-300",
    attrs: {
      "to": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end grow-1 align-items-center"
  }, [(_vm.memberCount >= 0) ? _c('span', {
    staticClass: "tag is-medium spaced mr-2"
  }, [_vm._v(_vm._s(_vm.memberCount) + " members")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tag is-medium spaced w-80px",
    class: {
      'is-primary': _vm.public,
      'is-warning': _vm.closed,
      'is-danger': _vm.private
    }
  }, [_vm._v(_vm._s(_vm.privacySettingLabel))]), _vm._v(" "), (_vm.isMember || _vm.sentLeave) ? _c('button', {
    staticClass: "button is-danger ml-4 w-90px",
    class: _vm.loading && 'is-loading',
    on: {
      "click": function($event) {
        _vm.showConfirm = true
      }
    }
  }, [_vm._v("Leave")]) : (_vm.public) ? _c('button', {
    staticClass: "button is-success ml-4 w-90px",
    class: _vm.loading && 'is-loading',
    on: {
      "click": _vm.joinTeam
    }
  }, [_vm._v("Join")]) : (_vm.requested || _vm.sentRequest) ? _c('button', {
    staticClass: "button is-primary ml-4 w-90px",
    class: _vm.loading && 'is-loading',
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Requested")]) : (_vm.closed) ? _c('button', {
    staticClass: "button is-success ml-4 w-90px",
    class: _vm.loading && 'is-loading',
    on: {
      "click": _vm.joinTeam
    }
  }, [_vm._v("Request")]) : _c('button', {
    staticClass: "button ml-4 w-90px",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Closed")])]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "message": _vm.confirmMessage,
      "title": 'Leave Team',
      "confirmFocus": true,
      "completeButtonText": 'Leave'
    },
    on: {
      "confirm": _vm.leaveTeam,
      "cancel": function($event) {
        _vm.showConfirm = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-57038c3f"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupElement.vue
// module id = 1040
// module chunks = 0